const STORAGE_KEY = "ss:recent-searches";
const MAX_RECENT_SEARCHES = 5;

/**
 * Read the user's recent free-text searches, most recent first.
 * Returns an empty array when storage is unavailable or empty.
 */
export function getRecentSearches(): string[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed
      .filter((item): item is string => typeof item === "string")
      .slice(0, MAX_RECENT_SEARCHES);
  } catch {
    return [];
  }
}

/**
 * Record a free-text search term. Trims, de-duplicates case-insensitively,
 * moves the term to the front, and caps the list. Returns the updated list.
 */
export function addRecentSearch(term: string): string[] {
  const trimmed = term.trim();
  if (!trimmed) return getRecentSearches();

  const existing = getRecentSearches().filter(
    (item) => item.toLowerCase() !== trimmed.toLowerCase()
  );
  const next = [trimmed, ...existing].slice(0, MAX_RECENT_SEARCHES);

  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    // Ignore write failures (e.g. private mode / quota); state still updates.
  }

  return next;
}

export { STORAGE_KEY as RECENT_SEARCHES_KEY };
